export enum MeetingOutcomeKeys {
  cancelled = 'Cancelled',
  completed = 'Completed',
  noShow = 'No Show',
  rescheduled = 'Rescheduled',
  schedules = 'Scheduled',
}
